const BASE_PATH = "/Civi_Circle_Admin-mobileview";

const CitycollabNavigationRoutes = {
    // OnBoarding Routes
    CREATE_ONBOARDING: `${BASE_PATH}/`,
    EDIT_ONBOARDING: (id: string) => `${BASE_PATH}/edit-onboarding/${id}`,
    EDIT_ONBOARDING_ROUTE: `${BASE_PATH}/edit-onboarding/:id`,
    ONBOARDING_LIST: `${BASE_PATH}/onboarding-list`,

    // Onboarding Homepage
    OnboardingHomepage: `${BASE_PATH}/OnboardingHomepage`,

    // Profile Page
    Profilepage: `${BASE_PATH}/Profilepage`,

    // Member Registration
    MemberRegistrationPage: `${BASE_PATH}/MemberRegistrationPage`,
    EDIT_MEMBER: (id: string) => `${BASE_PATH}/MemberRegistrationPage/${id}`,
    EDIT_MEMBER_ROUTE: `${BASE_PATH}/MemberRegistrationPage/:id`,

    // Login / Invite / Signup
    LoginPage: `${BASE_PATH}/LoginPage`,
    InviteErrorPage: `${BASE_PATH}/InviteErrorPage`,
    InviteExpiredPage: `${BASE_PATH}/InviteExpiredPage`,
    SignUpPage: `${BASE_PATH}/SignUpPage`,

    // Member List
    MemberListPage: `${BASE_PATH}/MemberListPage`,

    // Member Directory
    MemberDirectoryPage: `${BASE_PATH}/MemberDirectoryPage`,

    // Payment
    PaymentPage: `${BASE_PATH}/PaymentPage`,

    // Organisation Pages
    Organisationlistpage: `${BASE_PATH}/Organisationlistpage`,
    Organisationdetailpage: `${BASE_PATH}/Organisationdetailpage`,

    // Zulip Chat
    ChatPage: `${BASE_PATH}/chat`,

    // User Event Page
    UserEventPage: `${BASE_PATH}/Usereventpage`,
    SingleEventPage: `${BASE_PATH}/SingleEventPage`,

    // Buy Ticket Page
    BuyTicketPage: `${BASE_PATH}/BuyTicketPage`,
    PostsPage: `${BASE_PATH}/posts`,

    // Civi_Circle_User Routes
    NEW_DESIGN: `/home`,
    EVENTS: `/events`,
    DIRECTORY: `/directory`,
    SOP_LIBRARY: `/sop-library`,
    CHANNELS: `/channels`,
    DONATIONS: `/donations`,
    VOLUNTEERING: `/volunteering`,
    SPONSORSHIP: `/sponsorship`,
    MESSAGES: `/messages`,
    NOTIFICATIONS: `/notifications`,
    SETTINGS: `/settings`,
    PROFILE: `/profile`,
    RETIREE_MARKETPLACE: `/retiree-marketplace`,
    EVENT_TICKETS: `/event-tickets`,
    EVENT_PAYMENT: `/event-payment`,
};

export default CitycollabNavigationRoutes;
